import { NavLink } from "react-router-dom";
import "./location-navigation.scss";
import "./inner-page-navigation.scss";
import { getValue } from "@utils/lodash";
import BackSvgComponent from "@assets/svg-components/back";
import { toast } from "react-toastify";

export default function AdminNavigation(props: any) {
  return (
    <div className="common-sticky-header">
      <section className="inner-page-navigation-with-back-cta-buttons position-relative">
        <div className="container-fluid  d-flex justify-content-between align-items-center">
          <div className="d-flex">
            <NavLink
              to={getValue(props, `url`, "") ? getValue(props, `url`, "") : `#`}
            >
              <BackSvgComponent />
            </NavLink>
            <div className="inner-page-navigation-with-back-cta-button__header">
              <h4 className="inner-page-navigation-with-back-cta-button__header-title">
                {getValue(props, `title`, "")}
              </h4>
            </div>
          </div>
          {!getValue(props, `hideHeaderMenu`, false) && (
            <ul className="inner-page-navigation-with-back-cta-buttons__navigation d-inline-flex position-absolute">
              {!props.id && (
                <li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
                  <NavLink
                    to={`/admin/user-controls/users/add`}
                    className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
                  >
                    {getValue(props, `headerTitle`, "")
                      ? getValue(props, `headerTitle`, "")
                      : "Create User"}
                  </NavLink>
                </li>
              )}
              {props.id && props.id !== "undefined" && (
                <>
                  <li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
                    <NavLink
                      to={`/admin/user-controls/users/overview/${props.id}`}
                      className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
                    >
                      Overview
                    </NavLink>
                  </li>
                  <li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
                    <NavLink
                      to={`/admin/user-controls/users/delegation/${props.id}`}
                      className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
                    >
                      Delegation
                    </NavLink>
                  </li>
                </>
              )}
            </ul>
          )}
          {getValue(props, `permissions`, []).includes("update") &&
          !props.hideActionButtons ? (
            <div>
              {/* Hide cancel button for delegation screen */}
              {!getValue(props, `hideCancel`, false) && (
                <NavLink to={props.url}>
                  <button className="ascent-button ascent-button--header-buttons ascent-button--primary">
                    Cancel
                  </button>
                </NavLink>
              )}

              {getValue(props, `inviteLink`, "") && (
                <NavLink onClick={(e: any) => e.preventDefault()}>
                  <button
                    className="ascent-button ascent-button--header-buttons ascent-button--primary"
                    onClick={() => {
                      if (props.inviteLink) {
                        navigator.clipboard
                          .writeText(props.inviteLink)
                          .then(() => {
                            toast.success("Invite link copied to clipboard!");
                          })
                          .catch((err) => {
                            console.error("Failed to copy:", err);
                            toast.error("Failed to copy invite link");
                          });
                      }
                    }}
                  >
                    Copy Invite Link
                  </button>
                </NavLink>
              )}

              {props.isLoading ? (
                <button className="ascent-button ascent-button--header-buttons ascent-button--secondary">
                  Please wait...
                </button>
              ) : (
                <button
                  className={`ascent-button ascent-button--header-buttons ascent-button--secondary`}
                  onClick={props.handleSubmit}
                >
                  {/* Show "Update" for delegation screen, "Save" for new users, "Update" for existing users */}
                  {getValue(props, `hideCancel`, false)
                    ? "Update"
                    : props.id
                    ? "Update"
                    : "Save"}
                </button>
              )}
            </div>
          ) : !props.hideActionButtons ? (
            <button
              className={`ascent-button ascent-button--header-buttons ascent-button-secondary`}
            >
              .
            </button>
          ) : null}
        </div>
      </section>
    </div>
  );
}
